export default "https://cdn-static.gokick.com/assets/510b01776e4307c2b342e37a2ed4ce502ef69aad/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";